import { render, staticRenderFns } from "./selectAdmin.vue?vue&type=template&id=46ebed5a&scoped=true&"
import script from "./selectAdmin.vue?vue&type=script&lang=js&"
export * from "./selectAdmin.vue?vue&type=script&lang=js&"
import style0 from "./selectAdmin.vue?vue&type=style&index=0&id=46ebed5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ebed5a",
  null
  
)

export default component.exports